import React from 'react';
import './userTutorialCards.module.scss';
import { AllUserTutorialCompletionKeys } from '../../../types/userTutorialCompletions';
import { SpBr } from '../../../../commonv3/components/atoms/layouts/br';
import { UserTutorialCard } from '../../molecules/user_tutorial/UserTutorialCard';
import ImageShechanCelebrate from './images/she_chan_celebrate.svg';
import Slider from 'react-slick';

export const UserTutorialCards = () => {
    return (
        <div styleName="user-tutorial-pane" id="user-tutorial-cards">
            <div styleName="user-tutorial-header">
                <div styleName="user-tutorial-header-title">まずはこちらに取り組んでみよう！</div>
                <div styleName="user-tutorial-header-description">
                    SHElikesへのご入会おめでとうございます！<SpBr />これから一緒に頑張りましょう！<br />まずはこちらに取り組んでみてください✨
                </div>
            </div>
            <div styleName="user-tutorial-cards">
                {AllUserTutorialCompletionKeys.map((page_key, idx) => {
                    return <UserTutorialCard key={idx} page_key={page_key} />;
                })}
            </div>
            <img styleName="she_chan_celebrate" src={ImageShechanCelebrate} />
        </div>
    );
};

export const UserTutorialCardSp = () => {
    const settings = {
        className: 'slider variable-width',
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        adaptiveHeight: true,
        variableWidth: true,
        touchThreshold: 1000,
    };
    return (
        <div styleName="user-tutorial-pane" id="user-tutorial-cards">
            <div styleName="user-tutorial-header">
                <div styleName="user-tutorial-header-title">まずはこちらに取り組んでみよう！</div>
                <div styleName="user-tutorial-header-description">
                    SHElikesへのご入会おめでとうございます！<SpBr />これから一緒に頑張りましょう！<br />まずはこちらに取り組んでみてください✨
                </div>
            </div>
            <div styleName="user-tutorial-cards">
                <Slider {...settings}>
                    {AllUserTutorialCompletionKeys.map((page_key, idx) => (
                        <UserTutorialCard key={idx} page_key={page_key} />
                    ))}
                </Slider>
            </div>
        </div>
    );
};
